export default __webpack_public_path__ + "static/media/overhead.a508d1b8.svg";